import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import YouTube from "react-youtube";

import RatioBox from "./RatioBox";

const VideoWrapper = styled.div`
  background-color: #000;
`;

const AudioWrapper = styled.div`
  height: 44px;
  width: 100%;
  background-color: #000;
`;

const propTypes = {
  id: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  mediaType: PropTypes.string.isRequired,
  cover: PropTypes.string,
  jwPlatformID: PropTypes.string
};

class MediaPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tracked: false
    };
  }

  getYouTubeID = url => {
    url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return undefined !== url[2] ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  };

  isAudio = () =>
    this.props.mediaType && this.props.mediaType.startsWith("audio");

  isYoutube = () => this.props.src && this.props.src.includes("youtube.com");

  isAudioboom = () => 
    this.props.mediaType && this.props.mediaType === "embed/audioboom";

  isVimeo = () => 
    this.props.mediaType && this.props.mediaType.includes("vimeo");

  isEmbed = () => (this.isYoutube() || (this.props.mediaType && this.props.mediaType.startsWith("embed")))


    handlePlay = () => {
      if (!this.state.tracked) {
      this.setState({ tracked: true }, () => {
        window.track("media", {
          action: "play",
          mediaAssetId: this.props.id
        });
      });
    }
  };

  

  componentDidMount() {
    /*
    if(!this.isEmbed()){
      const jwplayer = window.jwplayer(this.props.id);
      let audioSetup = {};
      if (this.isAudio()){
        audioSetup = {
          width: "auto",
          height: 40
        }
      }
      
      jwplayer.setup({
        file: this.props.src,
        image:
          this.props.cover ||
          "https://s3-eu-west-1.amazonaws.com/vox.assets.public/site-assets/cover.png",
        mediaid: this.props.jwPlatformID,
        ...audioSetup
      });

      jwplayer.on("play", this.handlePlay);
    }
    */
  }

  
  render() {
    return (
      <div>
        {this.isAudio() ? (
          <AudioWrapper>
            <div id={this.props.id} />
          </AudioWrapper>
        ) : (
          <VideoWrapper>
            <RatioBox ratio="9/16">
              {this.isYoutube() && (
                <YouTube
                  videoId={this.getYouTubeID(this.props.src)}
                  opts={{
                    width: "100%",
                    height: "100%",
                    playerVars: { showinfo: 0 }
                  }}
                />
              )}
              {
                this.isAudioboom() && (
                  <iframe width="100%" height="210" src={`${this.props.src.replace('https://audioboom', 'https://embeds.audioboom')}/embed/v4`} style={{backgroundColor:"transparent", display:"block", padding: 0, maxWidth:"100%", height:'100%', minHeight: '210px'}} frameBorder="0" allowtransparency="allowtransparency" scrolling="no"></iframe>
                )
              }
          {
            this.isVimeo() && (
              <iframe src={this.props.src} width="100%" height="100%" frameborder="0" allow="fullscreen; picture-in-picture" allowfullscreen></iframe>
            )
              }
          { !this.isEmbed && (<div id={this.props.id} />) }
            </RatioBox>
          </VideoWrapper>
        )}
      </div>
    );
  }
}

MediaPlayer.propTypes = propTypes;

export default MediaPlayer;
